import { todayISO } from "@/lib/format";

export const IT_MONTHS = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
export const IT_MONTHS_SHORT = ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"];
export const IT_DOW_LETTER = ["L", "M", "M", "G", "V", "S", "D"]; // Monday-first
const IT_DAY_FULL = ["LUNEDÌ", "MARTEDÌ", "MERCOLEDÌ", "GIOVEDÌ", "VENERDÌ", "SABATO", "DOMENICA"];

// Europe/Rome users run the browser in local (Rome) time; dates are plain "YYYY-MM-DD".
export const ymd = (y, m, d) => `${y}-${String(m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
export const parseYMD = (s) => { const [y, m, d] = String(s).slice(0, 10).split("-").map(Number); return new Date(y, m - 1, d); };
export const dowMon0 = (dateStr) => (parseYMD(dateStr).getDay() + 6) % 7; // Mon=0..Sun=6
export const diffDays = (aStr, bStr) => Math.round((parseYMD(aStr) - parseYMD(bStr)) / 86400000);

export const relativeLabel = (dateStr) => {
  const d = diffDays(dateStr, todayISO());
  if (d === 0) return "Oggi";
  if (d === 1) return "Domani";
  if (d === 2) return "Dopodomani";
  return null;
};

export const dayHeader = (dateStr) => {
  const dt = parseYMD(dateStr);
  const dow = IT_DAY_FULL[dowMon0(dateStr)].slice(0, 3);
  return `${dow} ${dt.getDate()} ${IT_MONTHS[dt.getMonth()].toUpperCase()}`;
};

export const shortDate = (dateStr) => {
  const dt = parseYMD(dateStr);
  return `${dt.getDate()} ${IT_MONTHS_SHORT[dt.getMonth()]}`;
};

// 0 → "" (no duration); null/invalid/negative/non-integer → "—".
export const fmtDuration = (min) => {
  if (min === 0 || min === "0") return "";
  const m = typeof min === "string" && min.trim() !== "" ? Number(min) : min;
  if (typeof m !== "number" || !Number.isInteger(m) || m < 0) return "—";
  const d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), r = m % 60;
  const parts = [];
  if (d) parts.push(d === 1 ? "1 giorno" : `${d} giorni`);
  if (h) parts.push(`${h} h`);
  if (r) parts.push(`${r} min`);
  return parts.join(" ");
};

const sortKey = (s) => `${String(s.date).slice(0, 10)} ${s.start_time || "99:99"} ${s.id || ""}`;
export const sessSort = (a, b) => (sortKey(a) < sortKey(b) ? -1 : sortKey(a) > sortKey(b) ? 1 : 0);

// Chronological planned sessions from today forward (Europe/Rome).
export const upcomingPlanned = (sessions, limit) => {
  const t = todayISO();
  const list = (sessions || []).filter((s) => s.status === "Pianificata" && String(s.date).slice(0, 10) >= t).sort(sessSort);
  return typeof limit === "number" ? list.slice(0, limit) : list;
};

export const groupByDay = (sessions) => {
  const map = new Map();
  for (const s of [...(sessions || [])].sort(sessSort)) {
    const key = String(s.date).slice(0, 10);
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(s);
  }
  return map;
};
